import * as React from 'react';
import MaskInput, { Mask } from 'react-native-mask-input';
import useThemeColor from '../../hooks/useThemeColor';

import { Controller } from 'react-hook-form';
import Text from './Text';
import View from './View';
import Colors from '../../constants/Colors';

type ThemeProps = {
  lightColor?: string;
  darkColor?: string;
  width?: number;
  label?: string;
  control: any;
  name: string;
  required?: boolean;
  errors: any;
  errorMessage?: string;
  style?: any;
  mask?: Mask;
  keyboardType?: any;
  type?: any;
  rules?: any;
};

//export type InputProps = ThemeProps & DefaultTextInput['props'];

export default function MaskedTextInput(props: ThemeProps) {
  const { style, lightColor, darkColor, width, label, control, required, name, errors, errorMessage, mask, keyboardType, type,rules={required:required}, ...otherProps } = props;
  const backgroundColor = useThemeColor({ light: lightColor, dark: darkColor }, 'background');
  const color = useThemeColor({ light: darkColor, dark: lightColor }, 'text');
  const _width = width || '100%';

  return (
    <Controller
      control={control}
      rules={rules}
      render={({ field: { onChange, onBlur, value } }) => (
        <View style={{ justifyContent: 'center', width: _width }} lightColor="transparent" darkColor="transparent">
          {label && (
            <Text
              size={16}
              lineHeight={20}
              style={{
                alignSelf: 'flex-start',
                marginBottom: 4,
              }}
              weight="SemiBold"
              lightColor={Colors.nuetral_grey_700}
            >
              {label}
              {errors[name] && (
                 <Text size={16} lightColor={Colors.go_danger_500} darkColor={Colors.go_danger_500}>
                 *
               </Text>
              )}
            </Text>
          )}
          <MaskInput
            onBlur={onBlur}
            onChangeText={(text) =>

               onChange(text)
            }
            maskAutoComplete={true}
            placeholderFillCharacter='_'
            value={value}
            keyboardType={keyboardType}
            type={type}
            mask={mask}
            allowFontScaling={false}
            maxFontSizeMultiplier={1}
            style={[
              {
                alignSelf: 'flex-start',
                backgroundColor,
                color,
                paddingVertical: 8,
                paddingHorizontal: 12,
                borderRadius: 4,
                width: _width,
                borderColor: errors[name] ? Colors.go_danger_200 : Colors.nuetral_grey_400,
                borderWidth: 1,
              },
              style,
            ]}
            {...otherProps}
          />
           {errors[name] && <Text lightColor={Colors.go_danger_500} darkColor={Colors.go_danger_500}>{errorMessage}</Text>}
        </View>
      )}
      name={name}
    />
  );
}
